import { CarKeyIcon } from './CarKeyIcon';

/**
 * author: GreenTurtwig
 * id 3B659932-957C-4DD8-81CF-7ECABC572BFC
 * name car-key
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/car-key.svg
 * tags
 * - Transportation + Road 
 * - Automotive 
 */
export const CarRentalIcon = CarKeyIcon;
export default CarRentalIcon